/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const Settings = require('./Settings');

const Registry = {
	'Settings': Settings,
	'JSG.graph.layout.Settings': Settings
};

module.exports = {
	get(name) {
		return Registry[name];
	}
};
